import type { Zorm } from 'react-zorm';
import { z } from 'zod';

const ForgottenPasswordSchema = z.object({
	custom: z.string().optional(),
	email: z
		.string()
		.email('Not a valid email...')
		.transform((email) => email.toLowerCase()),
	redirectTo: z.string().optional(),
});

export default ForgottenPasswordSchema;

export type ForgottenPasswordSchemaZormType = Zorm<typeof ForgottenPasswordSchema>;
